/**
 * DraftPrompt.jsx
 * ---------------
 * Shown at the top of a service form when the server returns
 * an existing draft. Lets the member choose to continue or start fresh.
 */

import React from 'react'
import { useLanguage } from '../LanguageContext'

function fmtDraftDate(iso, locale) {
  if (!iso) return null
  return new Date(iso).toLocaleDateString(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

export default function DraftPrompt({ draft, onContinue, onStartNew, serviceName }) {
  const { t, lang } = useLanguage()
  const locale = lang === 'fr' ? 'fr-BE' : lang === 'nl' ? 'nl-BE' : 'en-GB'

  if (!draft) return null

  const savedRaw = fmtDraftDate(draft.updated_at, locale)
  const savedDate = savedRaw || t('draftPreviously')

  return (
    <div className="draft-prompt" role="region" aria-label={t('draftSavedAria')}>
      <div className="draft-prompt__inner">
        <div className="draft-prompt__icon" aria-hidden="true">◈</div>
        <div className="draft-prompt__body">
          <p className="draft-prompt__heading">{t('draftSavedFound')}</p>
          <p className="draft-prompt__detail">
            {t('draftDetail', { serviceName, savedDate })}
          </p>
        </div>
        <div className="draft-prompt__actions">
          <button
            type="button"
            className="svc-btn-primary draft-prompt__btn-primary"
            onClick={onContinue}
          >
            {t('continueDraft')}
          </button>
          <button
            type="button"
            className="svc-btn-ghost draft-prompt__btn-ghost"
            onClick={onStartNew}
          >
            {t('startNew')}
          </button>
        </div>
      </div>
    </div>
  )
}
